function getOrderOnlineLink(title) {
  const linkMap = {
    "p-wing-snob-edmonton-brewery-district": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-edmonton-eversquare": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-edmonton-northgate": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-edmonton-meadows": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-edmonton-manning": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-edmonton-albany": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-sherwood-park": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-edmonton-rabbit-hill": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-leduc": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-calgary-legacy": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    "p-wing-snob-edmonton-hamptons": "https://neworders.iorders.online/wing-snob-edmonton-brewery-district",
    
    // "p-subexpress-regina-quance":"N/A",
  };
  
  return linkMap[title] || `https://neworders.iorders.online/${title}`;
}

// ... rest of the code remains unchanged
const storeDetails = {
  status: "success",
  data: {
    restaurants: [
      //1. Wing Snob Edmonton - Brewery District
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Brewery District",
          title: "p-wing-snob-edmonton-brewery-district",
          address: "11988-104 Avenue Bldg 4, Edmonton, AB T5K 2G2",
          phone: "+1 (780) 760-9464",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.5461",
          lng: "-113.4938",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //2. Wing Snob Edmonton - Eversquare
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Eversquare",
          title: "p-wing-snob-edmonton-eversquare",
          address: "4624 Gateway Blvd NW, Edmonton, AB T6H 4P1",
          phone: "+1 (587) 635-0792",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.4734",
          lng: "-113.4909",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //3. Wing Snob Edmonton - Northgate
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Northgate",
          title: "p-wing-snob-edmonton-northgate",
          address: "9499 137 Ave NW Unit 1000, Edmonton, AB T5E 5R8",
          phone: "+1 (780) 244-5722",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.5851",
          lng: "-113.5458",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //4. Wing Snob Edmonton - Meadows
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Meadows",
          title: "p-wing-snob-edmonton-meadows",
          address: "1914 38 AVE NW, Edmonton, AB T6T 0B9",
          phone: "+1 (780) 244-3400",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.4734",
          lng: "-113.6309",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //5. Wing Snob Edmonton - Manning
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Manning",
          title: "p-wing-snob-edmonton-manning",
          address: "15558 37 St NW, Edmonton, AB T5Y 0S5",
          phone: "+1 (780) 540-9464",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "12:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "12:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "12:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "12:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "12:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "12:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.6309",
          lng: "-113.3909",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //6. Wing Snob Edmonton - Albany
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Albany",
          title: "p-wing-snob-edmonton-albany",
          address: "12772 167 Ave NW, Edmonton, AB T6V 1J6",
          phone: "+1 (780) 244-4173",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.6309",
          lng: "-113.5909",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //7. Wing Snob Sherwood Park
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Sherwood Park",
          title: "p-wing-snob-sherwood-park",
          address: "80-1020 Sherwood Drive, Sherwood Park, AB T8A 4N5",
          phone: "+1 (587) 269-1016",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.5309",
          lng: "-113.3109",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //8. Wing Snob Edmonton - Rabbit Hill
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Rabbit Hill",
          title: "p-wing-snob-edmonton-rabbit-hill",
          address: "5116 Mullen Road NW, Edmonton, AB T6R 0S9",
          phone: "+1 (780) 249-5774",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.4309",
          lng: "-113.6109",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //9. Wing Snob Edmonton - Hamptons
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Edmonton - Hamptons",
          title: "p-wing-snob-edmonton-hamptons",
          address: "20020 Lessard Rd NW, Edmonton, AB T6M 0T9",
          phone: "+1 (587) 415-3554",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.5309",
          lng: "-113.7109",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //10. Wing Snob Leduc
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Leduc",
          title: "p-wing-snob-leduc",
          address: "5411 Discovery Way Unit 108, Leduc, AB T9E 8N4",
          phone: "+1 (780) 739-2602",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.2309",
          lng: "-113.5509",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //11. Wing Snob Calgary - Legacy
      {
        profile: {
          id: 124,
          restaurant_name: "Wing Snob Calgary - Legacy",
          title: "p-wing-snob-calgary-legacy",
          address: "180 Legacy Main Street SE Unit #160, Calgary, AB T2X 4R9",
          phone: "+1 (825) 401-6080",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "50.8309",
          lng: "-113.9509",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
    ],
  },
  message: "successful response",
};

export default storeDetails;
